// PTI — Asset & User SaaS licensing model.
// Real-time protocols only (OPC UA, MQTT, SQL DB). Pure subscription.
// Prices aligned with the tag-based Hybrid Concurrent model so equivalent
// scale produces equivalent price:
//   assumption: ~100 tags per asset (typical industrial asset)
//   10 assets  ~ 1,000 tags  -> aligns with Lite base tag count
//   50 assets  ~ 5,000 tags  -> half of Business
//   100 assets ~ 10,000 tags -> Business
//   500 assets ~ 50,000 tags -> Professional
//   500+       = Enterprise / custom
// Pack prices match too:
//   +10 assets / mo = $99  (≈ $10 per 100-tag pack in tag model)
//   +10 users  / mo = $199 (≈ $20/user in existing PTI viewer add-on)

export const PTI_ASSETS_TIERS = [
  {
    id: 'rt_starter',
    label: 'Pilot',
    name: 'Starter',
    minAssets: 1, maxAssets: 10,
    users: 5,
    price: 100,
    tagsEquivalent: 1000,
    tagline: 'Prove real-time value on one line',
  },
  {
    id: 'rt_growth',
    label: 'Departmental',
    name: 'Growth',
    minAssets: 11, maxAssets: 50,
    users: 20,
    price: 500,
    tagsEquivalent: 5000,
    tagline: 'Scale across a department',
    popular: true,
  },
  {
    id: 'rt_scale',
    label: 'Multi-line',
    name: 'Scale',
    minAssets: 51, maxAssets: 100,
    users: 50,
    price: 1000,
    tagsEquivalent: 10000,
    tagline: 'Multiple production lines',
  },
  {
    id: 'rt_advanced',
    label: 'Full site',
    name: 'Advanced',
    minAssets: 101, maxAssets: 500,
    users: 100,
    price: 3000,
    tagsEquivalent: 50000,
    tagline: 'Blanket the entire plant site',
  },
  {
    id: 'rt_enterprise',
    label: 'Multi-site',
    name: 'Enterprise',
    minAssets: 501, maxAssets: 'Unlimited',
    users: 400,
    price: null,           // custom pricing
    tagsEquivalent: 'Unlimited',
    tagline: 'Corporate rollout across sites',
  },
];

export const PTI_ASSETS_PACK = {
  assetsPerPack: 10,
  assetPackPrice: 99,        // per pack per month — matches $10/100-tag pack in the tag model
  usersPerPack: 10,
  userPackPrice: 199,        // per pack per month — matches $20/user in the tag model
};

export const PTI_ASSETS_PROTOCOLS = [
  { id: 'opcua',  name: 'OPC UA',  description: 'Industrial control systems, PLCs, SCADA' },
  { id: 'mqtt',   name: 'MQTT',    description: 'IIoT gateways, edge devices, brokers' },
  { id: 'sqldb',  name: 'SQL DB',  description: 'MES, ERP, LIMS · live query' },
];

// Optional onboarding bundle (flat, one-time)
export const PTI_ASSETS_CONSULTING = {
  price: 5000,               // flat $5,000
  weeks: 5,
  optional: true,
  description: '5 weeks of onboarding, integration & training · optional',
};

export const PTI_ASSETS_ANNUAL_DISCOUNT = 0.15;
